export const publicRoutes = [
  '/login',
  '/signup',
  '/emailVerification',
  '/marketplace',
  '/checkout',
];
export const loginRoutes = ['/login', '/emailVerification', '/signup'];

export const isRootRoute = (path: string) => {
  return path === '/';
};

export const isPublicRoute = (path: string) => {
  return publicRoutes.some((route) => path === route || path.startsWith(route));
};

export const isWelcomeRoute = (path: string) => {
  return path === '/business';
};

export const openOnboarding = () => {
  window.open('/business', '_blank');
};
